import { createSlice } from "@reduxjs/toolkit";

import { clearStore } from "actions/initialization";
import { sendFeedbackThunk } from "thunks/auth";
import {
  deleteCalibrationThunk,
  renameCalibrationThunk,
} from "thunks/calibration";
import { deleteFolderThunk, updateFolderThunk } from "thunks/folder";
import { deleteProjectThunk, renameProjectThunk } from "thunks/project";
import { deleteRecordingThunk, updateRecordingThunk } from "thunks/recording";
import { isFulfilledAction } from "utils";

const initialModal = {
  open: false,
};

const initialState = {
  modals: {},
  loading: {
    feedback: false
  }
};

const actionsToFilter = {
  fulfilled: [
    renameCalibrationThunk.fulfilled,
    updateFolderThunk.fulfilled,
    deleteProjectThunk.fulfilled,
    deleteRecordingThunk.fulfilled,
    deleteCalibrationThunk.fulfilled,
    deleteFolderThunk.fulfilled,
    renameProjectThunk.fulfilled,
    updateRecordingThunk.fulfilled,
    sendFeedbackThunk.fulfilled,
  ],
};

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    initModal(state, action) {
      const { initialData, modalId } = action.payload;
      state.modals[modalId] = {
        ...initialModal,
        ...(initialData || {}),
      };
    },
    destroyModal(state, action) {
      const { modalId } = action.payload;
      if (state.modals[modalId]) {
        delete state.modals[modalId];
      }
    },
    toggleModal(state, action) {
      const { modalId, open } = action.payload;
      if (state.modals[modalId]) {
        state.modals[modalId].open = open;
      }
    },
    setDataModal(state, action) {
      const { modalId, data } = action.payload;
      if (state.modals[modalId]) {
        state.modals[modalId].data = data;
      }
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(clearStore, () => initialState)
      .addCase(sendFeedbackThunk.pending, (state) => {
        state.loading.feedback = true;
      })
      .addMatcher(
        isFulfilledAction(actionsToFilter.fulfilled),
        (state, action) => {
          const {
            meta: {
              arg: { modalId },
            },
          } = action;
          if (state.modals[modalId]) {
            state.modals[modalId].open = false;
          }
          state.loading.feedback = false;
        }
      )
});

export const actions = modalSlice.actions;

export default modalSlice.reducer;
